import React from "react";
import type * as CSS from 'csstype';

type Props = {
    style?: CSS.Properties;
}
const Header: React.FC<Props> = ({ style }) => {

    return (
        <div
            style={style}
        >
            <h1>
                midi-to-wav
            </h1>
            <ul
                style={ul}>
                <li>Upload a .mid file.</li>
                <li>We extract tracks in the .mid file and generate audio file for each of them.</li>
            </ul>

            <div style={notice}>
                <strong>&#x2139;&#xfe0f; Notice</strong>
                <ul style={noticeList}>
                    <li>Your MIDI file is not stored by this system.</li>
                    <li>The converted result is temporarily saved in cloud storage and will be automatically deleted after 1 day. This is because the system cannot return converted results (large files) directly.</li>
                    <li>We don't use your input data and converted results for any purpose.</li>
                </ul>
            </div>

        </div>

    )



};

const ul = {
    listStyleType: "none",
    padding: "0",
    margin: "0",
}

const notice: React.CSSProperties = {
    marginTop: "12px",
    fontSize: "0.85rem",
    color: "#555",
    lineHeight: "1.6",
    textAlign: "left",
}

const noticeList: React.CSSProperties = {
    marginTop: "4px",
    paddingLeft: "20px",
}

export default Header